import { render, staticRenderFns } from "./TerminatePlanDialog.vue?vue&type=template&id=5f5189a6&scoped=true&"
import script from "./TerminatePlanDialog.vue?vue&type=script&lang=js&"
export * from "./TerminatePlanDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5189a6",
  null
  
)

/* custom blocks */
import block0 from "./TerminatePlanDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VAlert,VBtn,VCheckbox})
